/*                                                                          */
/*                                                  */

/*                                             */
export const trackingPIArray = [
    "rum_deviceType",
    "rum_effectiveType",
    "rum_domComplete",
    "rum_supportsTouch",
    "rum_LCPElement",
    "rum_LCPURL",
    "rum_LCPTimeToFirstByte",
    "rum_LCPResourceLoadDelay",
    "rum_LCPResourceLoadDuration",
    "rum_LCPElementRenderDelay",
    "rum_FirstContentfulPaint",
    "rum_LargestContentfulPaint",
    "rum_sfid",
    /*                                                                                         */
];

/**
 *
 *
 *
 */
export const trackingEventArray = [];

